import { ProtectMode } from '../../../components/protect-mode'
import { ServerEnvironment } from '../../../components/server-environment'
import { ThisConnector } from '../../connector'
import { BaseApiResponse } from '../../shared'

export interface UpdateCveShieldArgs {
  organizationUuid: string
  ruleUuid: string
  environment: ServerEnvironment
  mode: ProtectMode
}

export async function updateCveShield(
  this: ThisConnector,
  { organizationUuid, ruleUuid, environment, mode }: UpdateCveShieldArgs
) {
  return this.connector.post<BaseApiResponse>(
    `${organizationUuid}/protection/rules/cve/${ruleUuid}/${environment}/${mode}`
  )
}
